import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { analytics, handleError } from "../helper/helper";
import tokenValidatorAxios from "../helper/axiosInstance";

// export const backend = "https://pplunar.crobo.money";
export const backend = "https://lunar.getbitmoneyapp.com";
// export const backend = "https://stage.getbitmoneyapp.com";
// export const backend = "http://localhost:3001";

export const ENVIRONMENT = () => {
  switch (backend) {
    case "https://pplunar.crobo.money":
      return "PREPROD";
    case "https://lunar.getbitmoneyapp.com":
      return false;
    case "https://stage.getbitmoneyapp.com":
      return "STAGING";
    case "http://localhost:3001":
      return "LOCAL";
    default:
      return "UNKNOWN";
  }
};

export const channel = () => {
  switch (backend) {
    case "https://pplunar.crobo.money":
      return "preprod";
    case "https://lunar.getbitmoneyapp.com":
      return "prod";
    case "https://stage.getbitmoneyapp.com":
      return "dev";
    case "http://localhost:3001":
      return "local";
  }
};

const getLocalStorageItem = (key) => {
  const item = localStorage.getItem(key);
  return typeof item === "string" ? JSON.parse(item) : item;
};

export const apiRoutes = {
  remitIdentityVerification: `${backend}/users/remitIdentityVerification`,
  remitStatusUpdate: `${backend}/users/remitstatusupdate/remitStatus`,
  auth: `${backend}/auth`,
  verifyOtp: `${backend}/otp/verify`,
  linkPhone: `${backend}/auth/link/phone`,
  register: `${backend}/auth/register`,
  profile: `${backend}/auth/profile`,
  verifyPin: `${backend}/auth/pin/verify`,
  setPin: `${backend}/auth/pin/set`,
  redeem: `${backend}/users/redeem`,
  fetchFrequentContact: `${backend}/users/fetchFrequentContact`,
  fetchUsers: `${backend}/users/V2/fetch`,
  redeemHistory: `${backend}/users/redeem-history`,
  referralHistory: `${backend}/users/referee-history`,
  resendGcCode: `${backend}/users/sendgccode`,
  getRecipients: `${backend}/users/recipients`,
  recipientsAction: `${backend}/users/recipient`,
  recipientsActionV2: `${backend}/users/v2/recipient`,
  subscribeUser: `${backend}/waitlist`,
  preRegister: `${backend}/users/v3/preRegister`,
  createLimitRequest: `${backend}/users/create-limit-request`,
  riskScore: `${backend}/users/riskscore`,
  refreshToken: `${backend}/auth/token/refresh/`,
};

const status = {
  loading: "loading",
  succeeded: "succeeded",
  failed: "failed",
};

export const userSlice = createSlice({
  name: "user",
  initialState: {
    name: null,
    email: null,
    phone: localStorage.getItem("phone") || null,
    profile: getLocalStorageItem("profile"),
    loading: false,
    remitLoading: localStorage.getItem("remitLoading") || false,
    authToken: localStorage.getItem("authToken") || null,
    token: localStorage.getItem("token") || null,
    refreshToken: localStorage.getItem("refreshToken") || null,
    frequentContacts: getLocalStorageItem("frequentContacts") || [],
    kyc: localStorage.getItem("kyc") || null,
    bank: localStorage.getItem("bank") || null,
    bankVerification: localStorage.getItem("bankVerification") || null,
    custom_message: "",
    showDocumentsButton: false,
    bankDetails: null,
    guid: localStorage.getItem("guid") || null,
    customMessage: "",
    redeemHistory: [],
    fetchUser: getLocalStorageItem("fetchUser"),
    referralHistory: [],
    error: null,
    pinVerified: false,
    status: "idle",
    statusCode: 0,
    documentUploadUrl: null,
    recipients: getLocalStorageItem("recipients") || [],
    isNewUser: false,
    pin: localStorage.getItem("pin") ? true : false,
    totalRecipients: 0,
    isAuthenticated: localStorage.getItem("isAuthenticated") || false,
    userReady: false,
    frequentContactsLoading: false,
    socialLinked: false,
  },
  reducers: {
    logout: (state) => {
      state.userInfo = null;
      state.authToken = null;
      state.token = null;
      state.profile = null;
      state.isAuthenticated = false;
      localStorage.clear();
    },
    setToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem('token', action.payload);
    },
    setRefreshToken: (state, action) => {
      state.refreshToken = action.payload;
      localStorage.setItem('refreshToken', action.payload);
    },
    markPinDisable: (state) => {
      state.pinVerified = false;
    },
    clearMessage: (state) => {
      state.customMessage = "";
      state.error = null;
    },
    clearFetchUser: (state) => {
      state.fetchUser = null;
    },
    setLoader: (state, action) => {
      state.loading = action.payload;
    },
    setRemitLoaded: (state, action) => {
      state.remitLoading = action.payload;
    },
    setAuth: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setIsNewUser: (state, action) => {
      state.isNewUser = action.payload;
    },
    markPinExist: (state) => {
      localStorage.setItem("pin", true);
      state.pin = true;
    },
    markPinNotExist: (state) => {
      localStorage.setItem("pin", false);
      state.pin = false;
    },
    setName: (state, action) => {
      state.name = action.payload;
    },
    setEmail: (state, action) => {
      state.email = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.data.token.access_token;
        state.isNewUser = action.payload.data.isNewUser;
        state.phone = action.payload.data.phone;
        const phoneNumber = action.payload.data.phone.startsWith("+1")
          ? action.payload.data.phone
          : `+1${action.payload.data.phone}`;
        localStorage.setItem("phone", phoneNumber);
        localStorage.setItem(
          "pin",
          action.payload.data.pin === 1 ? true : false
        );
        state.pin = action.payload.data.pin === 1 ? true : false;
        state.isAuthenticated = true;
        state.error = null;
        state.pinVerified = false;
      })
      .addCase(login.pending, (state) => {
        state.loading = true;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.data.token.access_token;
        state.isNewUser = action.payload.data.isNewUser;
        localStorage.setItem(
          "pin",
          action.payload.data.pin === 1 ? true : false
        );
        state.pin = action.payload.data.pin === 1 ? true : false;
        state.isAuthenticated = true;
        state.error = null;
        state.pinVerified = false;
      })
      .addCase(verifyOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      .addCase(getProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        state.status = state.fulfilled;
        state.loading = false;
        state.profile = action.payload.data.data.user_profile;
        state.guid = action.payload.data.data.user_profile.external_guid;
        state.error = null;
      })
      .addCase(getProfile.rejected, (state, action) => {
        state.loading = false;
        state.errorCode = action.payload.code;
        state.error = action.error.message;
      })
      .addCase(verifyPin.pending, (state, action) => {
        state.status = status.pending;
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyPin.rejected, (state, action) => {
        state.status = status.failed;
        state.loading = false;
        state.error = action.payload.message;
      })
      .addCase(verifyPin.fulfilled, (state, action) => {
        state.status = status.succeeded;
        state.loading = false;
        state.pinVerified = true;
        state.error = null;
      })
      .addCase(pinSet.pending, (state, action) => {
        state.status = status.pending;
        state.loading = true;
        state.error = null;
      })
      .addCase(pinSet.rejected, (state, action) => {
        state.status = status.failed;
        state.loading = false;
        state.error = action.payload.message;
      })
      .addCase(pinSet.fulfilled, (state, action) => {
        state.status = status.succeeded;
        localStorage.setItem("pin", true);
        state.pinVerified = true;
        state.pin = true;
        state.error = null;
      })
      .addCase(redeem.pending, (state) => {
        state.loading = true;
      })
      .addCase(redeem.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(redeem.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      .addCase(frequentContact.pending, (state) => {
        state.frequentContactsLoading = localStorage.getItem("frequentContacts")
          ? false
          : true;
      })
      .addCase(frequentContact.fulfilled, (state, action) => {
        state.frequentContactsLoading = false;
        state.frequentContacts = action.payload.data.data;
        state.error = null;
      })
      .addCase(frequentContact.rejected, (state, action) => {
        state.frequentContactsLoading = false;
        state.error = action.error.message;
      })
      .addCase(remitStatusUpdate.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(remitStatusUpdate.fulfilled, (state, action) => {
        state.loading = false;
        state.remitLoading = true;
        state.kyc = action.payload.kyc;
        state.bank = action.payload.bank;
        state.bankVerification = action.payload.bank_verification;
        state.customMessage = action.payload.customer_message;
        state.showDocumentsButton =
          action.payload.additional_documents_required;
        state.bankDetails = action.payload.bank_details;
        localStorage.setItem("remitLoading", true);
        localStorage.setItem("kyc", action.payload.kyc);
        localStorage.setItem("bank", action.payload.bank);
        localStorage.setItem(
          "bankVerification",
          action.payload.bank_verification
        );
        state.userReady = true;
      })
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.fetchUser = action.payload.data;
        state.error = null;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getRedeemHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRedeemHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.redeemHistory = action.payload.data.data;
        state.error = null;
      })
      .addCase(getRedeemHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getReferralHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(getReferralHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.referralHistory = action.payload.data.data;
        state.error = null;
      })
      .addCase(getReferralHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(remitDocumentUpload.pending, (state, action) => {
        state.loading = true;
        state.remitLoading = true;
      })
      .addCase(remitDocumentUpload.fulfilled, (state, action) => {
        state.loading = false;
        state.remitLoading = false;
        state.documentUploadUrl = action.payload.inquiry_id;
        state.error = null;
        // if (action.payload.kyc_url)
        //   window.open(action.payload.kyc_url, "_blank");
      })
      .addCase(remitDocumentUpload.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getRecipients.pending, (state, action) => {
        state.loading = localStorage.getItem("recipients") ? false : true;
      })
      .addCase(getRecipients.fulfilled, (state, action) => {
        state.loading = false;
        state.recipients = action.payload.data;
        state.totalRecipients = action.payload.totalPage;
      })
      .addCase(getRecipients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(subscribeUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(subscribeUser.fulfilled, (state, action) => {
        state.loading = false;
        state.customMessage = action.payload.message;
      })
      .addCase(subscribeUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      .addCase(getRiskScore.fulfilled, (state, action) => {
        state.riskScore = action.payload.risk_score;
      })
      .addCase(refreshToken.fulfilled, (state, action) => {
        state.token = action.payload.access_token;
        state.refreshToken = action.payload.refresh_token;
      })
      .addCase(refreshToken.rejected, (state, action) => {
        state.error = action.payload.message;
      })
      .addCase(updateRecipient.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateRecipient.fulfilled, (state, action) => {
        state.loading = false;
        state.recipients = state.recipients.map((recipient) =>
          recipient.id === action.payload.id ? action.payload : recipient
        );
      })
      .addCase(updateRecipient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      .addCase(deleteRecipient.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteRecipient.fulfilled, (state, action) => {
        state.loading = false;
        state.recipients = state.recipients.filter(
          (recipient) => recipient.id !== action.payload.id
        );
      })
      .addCase(deleteRecipient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      });
  },
});

export const login = createAsyncThunk(
  "user/auth",
  async (param, { dispatch, rejectWithValue }) => {
    const utmParams = JSON.parse(localStorage.getItem("utmParams") || "{}");
    try {
      let config = {
        method: "post",
        url: apiRoutes.auth,
        headers: { accessToken: param.authToken },
        data: { utmParams },
      };
      const payload = await axios.request(config);
      localStorage.setItem("authToken", param.authToken);
      localStorage.setItem("token", payload.data.token.access_token);
      localStorage.setItem("refreshToken", payload.data.token.refresh_token);
      localStorage.setItem("isAuthenticated", true);
      dispatch(
        remitStatusUpdate({
          token: payload.data.token.access_token,
          isRefresh: true,
        })
      );
      dispatch(getProfile());
      return payload;
    } catch (error) {
      return rejectWithValue(await handleError(error));
    }
  }
);

export const verifyOtp = createAsyncThunk(
  "user/verifyOtp",
  async (param, { dispatch, rejectWithValue }) => {
    const utmParams = JSON.parse(localStorage.getItem("utmParams") || "{}");
    try {
      let config = {
        method: "post",
        url: apiRoutes.verifyOtp,
        data: {
          utmParams,
          phoneNumber: param.phone.substring(2),
          otp: param.otp,
          countryCode: param.countryCode,
        },
      };
      const payload = await axios.request(config);
      localStorage.setItem("token", payload.data.token.access_token);
      localStorage.setItem("refreshToken", payload.data.token.refresh_token);
      localStorage.setItem(
        "phone",
        param.phone.startsWith("+1") ? param.phone : `+1${param.phone}`
      );
      localStorage.setItem("isAuthenticated", true);
      dispatch(
        remitStatusUpdate({
          token: payload.data.token.access_token,
          isRefresh: true,
        })
      );
      dispatch(getProfile());
      return payload;
    } catch (error) {
      return rejectWithValue(await handleError(error));
    }
  }
);

export const getProfile = createAsyncThunk(
  "user/profile",
  async (param, { rejectWithValue }) => {
    try {
      const payload = await tokenValidatorAxios.get(apiRoutes.profile);
      const profile = payload.data.data.user_profile;
      localStorage.setItem(
        "guid",
        payload.data.data.user_profile.external_guid
      );
      analytics.identify(profile.user_id, {
        name: profile.unverified_user_name,
        email: profile.email || profile.unverified_email,
        phone: localStorage.getItem("phone")
          ? localStorage.getItem("phone")
          : null,
      });
      window.clarity(
        "identify",
        `${profile.user_id}`,
        profile.unverified_email,
        "",
        profile.unverified_user_name
      );
      window.clarity("set", "guid", profile?.external_guid);
      return payload;
    } catch (error) {
      return rejectWithValue(await handleError(error));
    }
  }
);

export const verifyPin = createAsyncThunk(
  "user/pin/verify",
  async (pin, { rejectWithValue }) => {
    try {
      const payload = await tokenValidatorAxios.post(apiRoutes.verifyPin, { pin });
      return payload;
    } catch (error) {
      return rejectWithValue(await handleError(error));
    }
  }
);


export const pinSet = createAsyncThunk(
  "user/pin/set",
  async (pin, { dispatch, rejectWithValue }) => {
    try {
      const payload = await tokenValidatorAxios.post(apiRoutes.setPin, { pin });
      dispatch(getProfile());
      return payload;
    } catch (error) {
      return rejectWithValue(await handleError(error));
    }
  }
);

export const redeem = createAsyncThunk(
  "users/redeem",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const payload = await tokenValidatorAxios.post(apiRoutes.redeem, params);
      params.action();
      await dispatch(getProfile());
      return payload;
    } catch (error) {
      return rejectWithValue(await handleError(error));
    }
  }
);

export const frequentContact = createAsyncThunk(
  "user/frequentContact",
  async (_, { rejectWithValue }) => {
    try {
      const payload = await tokenValidatorAxios.get(apiRoutes.fetchFrequentContact);
      return payload;
    } catch (error) {
      return rejectWithValue(await handleError(error));
    }
  }
);

export const callFetchUsers = async (params) => {
  try {
    const payload = await tokenValidatorAxios.post(apiRoutes.fetchUsers, params);
    localStorage.setItem("fetchUser", JSON.stringify(payload.data));
    return payload;
  } catch (error) {
    return await handleError(error);
  }
};

export const fetchUsers = createAsyncThunk(
  "user/fetchUsers",
  async (params, { rejectWithValue }) => {
    try {
      const payload = await callFetchUsers(params);
      return payload;
    } catch (error) {
      return rejectWithValue(await handleError(error));
    }
  }
);

export const getRedeemHistory = createAsyncThunk(
  "users/redeem-history",
  async ({ page, pageSize, filter }, { rejectWithValue }) => {
    try {
      const url = `${apiRoutes.redeemHistory}?page=${page}&pageSize=${pageSize}&filter=${filter}`;
      const payload = await tokenValidatorAxios.get(url);
      return payload;
    } catch (error) {
      return rejectWithValue(await handleError(error));
    }
  }
);

export const getReferralHistory = createAsyncThunk(
  "users/referee-history",
  async ({ page, pageSize, filter }, { rejectWithValue }) => {
    try {
      const url = `${apiRoutes.referralHistory}?page=${page}&pageSize=${pageSize}&filter=${filter}`;
      const payload = await tokenValidatorAxios.get(url);
      return payload;
    } catch (error) {
      return rejectWithValue(await handleError(error));
    }
  }
);

export const remitStatusUpdateCall = async (isRefresh) => {
  try {
    const { data } = await tokenValidatorAxios.get(
      `${backend}/users/remitStatusUpdate/a?refresh=${isRefresh}`
    );
    return data;
  } catch (error) {
    return await handleError(error);
  }
};

export const remitStatusUpdate = createAsyncThunk(
  "users/remitstatusupdate/a",
  async ({ isRefresh = "true" }, { rejectWithValue }) => {
    try {
      return await remitStatusUpdateCall(isRefresh);
    } catch (error) {
      return rejectWithValue(await handleError(error));
    }
  }
);

export const remitDocumentUpload = createAsyncThunk(
  "users/remitIdentityVerification",
  async ({ type }, { rejectWithValue }) => {
    try {
      const { data } = await tokenValidatorAxios.post(
        `${backend}/users/remitIdentityVerification`,
        { type }
      );
      return data;
    } catch (error) {
      return rejectWithValue(await handleError(error));
    }
  }
);

export const resendGcCode = createAsyncThunk(
  "users/sendgccode",
  async (params, { rejectWithValue }) => {
    try {
      const payload = await tokenValidatorAxios.post(apiRoutes.resendGcCode, params);
      return payload;
    } catch (error) {
      return rejectWithValue(await handleError(error));
    }
  }
);

export const subscribeUser = createAsyncThunk(
  "subscription/subscribeUser",
  async (params, { rejectWithValue }) => {
    try {
      const payload = await tokenValidatorAxios.post(apiRoutes.subscribeUser, { email: params });
      return payload.data;
    } catch (error) {
      return rejectWithValue(await handleError(error));
    }
  }
);

export const getRecipients = createAsyncThunk(
  "users/getRecipients",
  async ({ page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const url = apiRoutes.getRecipients + `?page=${page}&perPage=${limit}`;
      const payload = await tokenValidatorAxios.get(url);
      return payload.data;
    } catch (error) {
      return rejectWithValue(await handleError(error));
    }
  }
);

export const updateRecipient = createAsyncThunk(
  "users/updateRecipient",
  async (params, { rejectWithValue }) => {
    try {
      const url = `${apiRoutes.recipientsActionV2}/${params.id}`;
      const payload = await tokenValidatorAxios.put(url, params);
      return payload.data;
    } catch (error) {
      return rejectWithValue(await handleError(error));
    }
  }
);

export const deleteRecipient = createAsyncThunk(
  "users/deleteRecipient",
  async (id, { rejectWithValue }) => {
    try {
      const url = `${apiRoutes.recipientsAction}/${id}`;
      const payload = await tokenValidatorAxios.delete(url);
      return payload.data;
    } catch (error) {
      return rejectWithValue(await handleError(error));
    }
  }
);

export const register = async (params) => {
  try {
    const payload = await tokenValidatorAxios.post(apiRoutes.register, params);
    return payload.data;
  } catch (error) {
    await handleError(error);
  }
};

export const getRiskScore = createAsyncThunk(
  "users/riskscore",
  async (params, { rejectWithValue }) => {
    try {
      const payload = await tokenValidatorAxios.get(apiRoutes.riskScore);
      return payload.data;
    } catch (error) {
      return rejectWithValue(await handleError(error));
    }
  }
);

export const refreshToken = createAsyncThunk(
  "user/refreshToken",
  async (_, { rejectWithValue }) => {
    const token = localStorage.getItem("refreshToken");
    try {
      let config = {
        method: "get",
        url: apiRoutes.refreshToken + token,
      };
      const payload = await axios.request(config);
      localStorage.setItem("token", payload.data.access_token);
      localStorage.setItem("refreshToken", payload.data.refresh_token);
      return payload.data;
    } catch (error) {
      return rejectWithValue(await handleError(error));
    }
  }
);

export const {
  logout,
  markPinDisable,
  clearMessage,
  clearFetchUser,
  setLoader,
  markPinNotExist,
  setRemitLoaded,
  setName,
  setEmail,
  setIsNewUser,
  setAuth,
  markPinExist,
  setToken,
  setRefreshToken,
} = userSlice.actions;
export default userSlice.reducer;
